module.exports = __webpack_public_path__ + "img/outline2.c39fdc9d.svg";